import {
  FATURA_LOAD,
  FATURA_LOAD_ORDER,
  FATURA_ACCEPT_ORDER
} from "../actions/fatura";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const state = {};

const getters = {};

const actions = {
  [FATURA_LOAD]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.billing
        .cost(getters.getEmpresaId, payload.newDate, payload.types)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [FATURA_LOAD_ORDER]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.billing
        .estimativaGasto(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [FATURA_ACCEPT_ORDER]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.billing
        .atualizaEstimativa(getters.getFornecedorId, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
